"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _Editor = _interopRequireDefault(require("./Editor"));

var _default = /*#__PURE__*/(0, _react.memo)(_Editor.default);

exports.default = _default;